import * as API from '../'

export default {
  // 种养类型字典
  getSubDicList: param => {
    return API.POST(process.env.codeAREA + "/dic/get/parent/number", param);
  },
  // 二级农技类型
  getDicList: param => {
    return API.POST(process.env.codeAREA + "/dic/list", param);
  },
  //农技服务列表接口
  agrotechnicalList(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/manage/list', params)
  },
  //农技服务新增接口
  addItem(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/save', params)
  },
  //农技服务编辑接口
  editItem(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/update', params)
  },
  // 详情
  getDetail(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/detail', params)
  },
  //农技服务删除接口
  deleteItem(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/delete', params)
  },
  //农技服务word下载接口
  downloadItem(params) {
    return API.POSTBLOB(process.env.EXPERTGUIDANCE + '/app/article/download/word', params)
  },
   //查询某一文章的文件列表
   articleFileList(params) {
    return API.POST(process.env.EXPERTGUIDANCE + '/app/article/file/list', params)
  },
}




// WEBPACK FOOTER //
// ./src/api/api_agrotechnical/api_agrotechnical.js